import React from "react";

import {
  ArrowClockwiseRegular,
  DismissRegular,
} from "@fluentui/react-icons";
import {
  Button,
  makeStyles,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
  tokens,
} from "@fluentui/react-components";

import { translate } from "@/utils/translations";

interface ErrorMessageProps {
  content: string;
  error: string;
  messageId: number;
  onDismiss: (messageId: number) => void;
  onRetry: (messageId: number) => void;
}

const useStyles = makeStyles({
  errorContainer: {
    display: "flex",
    marginBottom: tokens.spacingVerticalL,
    marginLeft: tokens.spacingHorizontalS,
    marginRight: tokens.spacingHorizontalS,
    marginTop: tokens.spacingVerticalL,
  },
  errorDetails: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
    marginTop: tokens.spacingVerticalXS,
  },
  messageBar: {
    flex: 1,
    maxWidth: "100%",
  },
});

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  content,
  error,
  messageId,
  onDismiss,
  onRetry,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.errorContainer}>
      <MessageBar
        className={styles.messageBar}
        intent="error"
      >
        <MessageBarBody>
          <MessageBarTitle>{content || translate("There is error. Please retry")}</MessageBarTitle>
          {error && <div className={styles.errorDetails}>{error}</div>}
          <Button
            appearance="primary"
			icon={<ArrowClockwiseRegular />}
            onClick={() => onRetry(messageId)}
            size="small"
            style={{ marginTop: tokens.spacingVerticalS }}
          >
            {translate("Retry")}
          </Button>
        </MessageBarBody>
        <MessageBarActions
          containerAction={
            <Button
              appearance="transparent"
              aria-label={translate("Dismiss")}
              icon={<DismissRegular />}
              onClick={() => onDismiss(messageId)}
            />
          }
        />
      </MessageBar>
    </div>
  );
};

export default ErrorMessage;
